import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary/index';
import LoadingSpinner from '../components/LoadingSpinner/index';
import DynamicScreen from '../pages/config/DynamicScreen/index';
import { useTheme } from '../theme/theme-provider';
// import DynamicScreen from '../pages/config/DynamicScreen/index';

// Example route paths following SEO & search standards:
// - Use kebab-case for readability
// - Keep paths descriptive but concise
// - Include relevant parameters
// - Group related routes together
// - Avoid special characters except hyphens
// - Use semantic naming that describes the resource
//
// Examples:
// /settings/user-profile
// /reports/monthly-summary/:year/:month
// /dashboard/overview
// /orders/create
// /orders/:orderId/details
// /orders/:orderId/edit
// /products/categories/:categoryId
// /products/:productId/variants
// /customers/list
// /customers/:customerId/orders
// /analytics/sales/:startDate/:endDate
// /admin/users/permissions

const NewSrcRoutes = () => {
  const { theme } = useTheme();
  return (
    <div id='nsr-root' className={theme === 'dark' ? 'dark' : ''}>
      <ErrorBoundary>
        <Suspense fallback={<LoadingSpinner />}>
          <Route exact path='/nsr/create-rfq/:id/:type/:isCopy?'>
            <DynamicScreen screenComponentName='RFQCreate' />
          </Route>
          <Route exact path='/nsr/rfq-view/:id/:serviceType/:type'>
            <DynamicScreen screenComponentName='RFQCreate' />
          </Route>
          <Route exact path='/nsr/seeker-home'>
            <DynamicScreen screenComponentName='SeekerHomeScreen' />
          </Route>
          <Route exact path='/nsr/rfq-dashboard'>
            <DynamicScreen screenComponentName='RfqDashboardScreen' />
          </Route>
          <Route exact path='/nsr/seeker-bids/:id/:type'>
            <DynamicScreen screenComponentName='BidDetailsScreen' />
          </Route>
          <Route exact path='/nsr/seeker-bids/:id/approval'>
            <DynamicScreen screenComponentName='BidDetailsScreen' />
          </Route>
          <Route exact path='/nsr/challenge-price-form/:id'>
            <DynamicScreen screenComponentName='ChallengePriceForm' />
          </Route>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default NewSrcRoutes;
